/**
 * Workflow actions constants.
 * URL in these constants are having dynamic variables
 * wrapped in {}, replace them with original dynamic variables
 * in order to send API requests.
 */

export const SCHEME_PROCESS_NAME = "SCHEME PLAN APPROVAL";
export const SCHEME_PAYOUT_COMMIUNICATION_APPROVAL = "SCHEME PAYOUT COMMIUNICATION APPROVAL";
export const SCHEME_PROCESS_TYPE = "SCHEME_PLAN";
export const SCHEME_PAYOUT_COMMUNICATION_PROCESS_TYPE = "SCHEME_PAYOUT_COMMUNICATION";
export const COMMUNICATION_PROCESS_TYPE = "SCHEME_COMMUNICATION";
export const SCHEME_WORKFLOW_TRIGGER =
  "/scheme-planning/ims/workflowtrigger?planNo={planNo}";
export const COMM_WORKFLOW_TRIGGER =
  "/communication/ims/schedule/workflowtrigger?scheduleId={scheduleNo}";
export const CREATE_USER_REQUEST_ID =
  "/workflowservice/ims/workflow/createUserRequest";
export const GET_WORKFLOW_ID = "/workflow-mgmt/workflow/orgInvoke/{requestId}";
export const GET_WORKFLOW_ID_IMS_URL = "/workflowservice/ims/workflow/definition";
export const FETCH_WORKFLOW_DEF =
  "/workflowservice/ims/workflow/workflow/definition?definitionId={defId}&requestId={reqId}";
export const GET_KNOX_USERS = "/workflow-mgmt/workflow/employeeSearch";
export const UPLOAD_APPROVAL_ATTACHMENTS = "/workflow-mgmt/workflow/uploadFile";
export const DELETE_APPROVAL_ATTACHMENTS =
  "workflow-mgmt/workflow/deleteFile/{docId}";
export const SUBMIT_APPROVAL =
  "/workflowservice/ims/workflow/workflow/workflowSubmit?defenitionId={defId}&planNo={planNo}&isRrfTot={isRrfTot}";
export const SCHEDULE_APPROVAL = "/workflowservice/ims/workflow/jobScheduling";
export const APPROVAL_STATUS =
  "/workflowservice/ims/workflow/definition?requestId={reqId}";
export const CANCEL_APPROVAL_SUBMISSION =
  "/workflowservice/ims/workflow/cancel/workflow?workflowRqstId={reqId}";
export const DOWNLOAD_APPROVAL_ATTACHMENTS =
  "/workflow-mgmt/workflow/downloadByDocID?docId={docId}&docName={docName}";
export const UPDATE_APPROVAL_STATUS =
  "/workflowservice/ims/workflow/updateCoreRecord?WorkFlowStatus={workflowStatus}";
export const SAVE_SUBMIT_SCHEDULE =
  "/workflowservice/ims/workflow/updatecommunicationStatus?scheduleNumber={scheduleNumber}";
export const SAVE_SUBMIT_ACCRUAL =
"/workflowservice/ims/workflow/updateAccuralStatus?accuralNumber={accuralNumber}";
export const ENTRY_IN_JOBQUE_LETTER_GENERATION="/workflowservice/ims/workflow/entryForLetter?planNumber={planNo}"
export const GET_RRFTOT_ZIP="/workflowservice/ims/workflow/getPdf?planNo={planNo}";
export const GET_RRFTOT_ZIP_IN_COMMUNICATION="/workflowservice/ims/workflow/getPdf?planNo={planNo}&revisionId={revId}";
export const FETCH_EMAIL_ATTACHMENT_COMM="/workflowservice/ims/workflow/emailAttachmentFiles?scheduleId={scheduleId}";
export const WORKFLOW_SUBMIT_COMMUNICATION_PTIS =
"/workflowservice/ims/workflow/workflowSubmitCommunicationPtis?definitionId={definitionId}&scheduleNo={scheduleNo}";
export const CANCEL_APPROVAL_COMM="/workflowservice/ims/workflow/cancel/workflow?workflowRqstId={workflowRqstId}";
export const CANCEL_REQUEST = "/scheme-planning/ims/revision/draft";
